module.exports = __webpack_public_path__ + "static/exam-480-programming-in-html5-with-javascript-and-css3-a81590a5d23311b0e003f6bca1fff2d4.png";